/*@ngInject*/
class CatalogController {
  constructor($scope, CurrentFilterService, FiltersService) {
    this.CurrentFilterService = CurrentFilterService;
    this.FiltersService = FiltersService;
    $scope.$watch('$ctrl.CurrentFilterService.filter', (filter) => {
      this.FiltersService.getPath(filter).forEach((f) => {
        f.isNodeOpen = true;
      });
    });
    $scope.$watch('$ctrl.filters', () => {
      this.FiltersService.getPath(this.CurrentFilterService.filter)
        .forEach((f) => {
          f.isNodeOpen = true;
        });
    });
  }
}

export const CatalogComponent = {
  template  : require('./catalog.component.html'),
  bindings  : {
    filters: '<',
  },
  controller: CatalogController,
};



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog.component.js